import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IVendorDetail} from "../types/IVendorDetail";

export const getVendorDetailApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getVendorDetail: build.query<IVendorDetail, number>({
            query: (vendorId) => apiV2Link.vendor.detail(Scenario.VENDOR_DETAIL, {vendorId})
        })
    })
});

export const {useGetVendorDetailQuery} = getVendorDetailApi;
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IVendorDetail} from "../types/IVendorDetail";

export const getVendorDetailApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getVendorDetail: build.query<IVendorDetail, number>({
            query: (vendorId) => apiV2Link.vendor.detail(Scenario.VENDOR_DETAIL, {vendorId})
        })
    })
});

export const {useGetVendorDetailQuery} = getVendorDetailApi;
